<template>
  <wo-region class="wo-u-align-right">
    <wo-button type="button" @click.native="emitCancel" v-t="'general.action.cancel'" tabindex="-1" mod-secondary></wo-button>
    <po-promise-button @click="emitConfirm" :label-key="labelKey" :disabled="!valid" type="submit" />
  </wo-region>
</template>
<script>
export default {
  name: 'PoConfirmationButtons',
  props: {
    valid: undefined,
    labelKey: { type: String, default: 'general.action.save' }
  },
  methods: {
    emitCancel () {
      this.$emit('cancel')
    },
    emitConfirm (e) {
      this.$emit('confirm', e)
    }
  }
}
</script>
